import { render } from "./CustomStat.vue?vue&type=template&id=13d69840&scoped=true&ts=true"
import script from "./CustomStat.vue?vue&type=script&lang=ts"
export * from "./CustomStat.vue?vue&type=script&lang=ts"

import "./CustomStat.vue?vue&type=style&index=0&id=13d69840&lang=scss&scoped=true"

import exportComponent from "/workspace/hound-platform/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13d69840"]])

export default __exports__